export const sumByField = (arr, field) => arr && arr.length ? arr.reduce((acc, curr) => acc + curr[field], 0) : 0

export const calculateGrowth = (asubs, filters) => {
  var A1 = asubs[0].ns, A2 = asubs[1].ns;
  if(!A1) A1 = 1
  var growth =  ((A2-A1)*100)/A1
  return growth > 1000 ? 1000 : growth;
}

export const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);



// WEBPACK FOOTER //
// ./src/helpers/general.js